var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrapper"}},[_c('lineMenu'),_c('div',{attrs:{"id":"wrapperInner"}},[_c('router-view',{attrs:{"con":_vm.con}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }